/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { z } from "zod";
const base = z.object({
  id: z.string().uuid(),
  createdAt: z.number(),
  updatedAt: z.number(),
  name: z.string(),
  deleted_at: z.number().nullable(),
});
const create = base.extend({
});
const update = base.partial();
const put = create.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
});
const patch = base.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
}).partial()
.extend({ id: z.string().uuid() });
const rows = z.array(base);
const rowsWithPaging = z.object({
  count: z.number(),
  rows: rows,
});
const cache = base.omit({
}).extend({ cachedAt: z.number() });
const caches = z.array(cache);
export const GroupBaseSchema = { base, put, patch, rows, rowsWithPaging, create, update, cache, caches };
export type GroupBase = z.infer<typeof base>;
export type GroupBasePutPayload = z.infer<typeof put>;
export type GroupBasePatchPayload = z.infer<typeof patch>;
export type GroupBaseRowsWithPaging = z.infer<typeof rowsWithPaging>;
export type GroupBaseCreateAttributes = z.infer<typeof create>;
export type GroupBaseUpdateAttributes = z.infer<typeof update>;
export type GroupBaseCacheAttributes = z.infer<typeof cache>;
export type GroupBaseCachesAttributes = z.infer<typeof caches>;